import PiCreatorDropdown from "../../../components/PiCreatorDropdown/PiCreatorDropdown";
import PiCreatorDropdownItem from "../../../components/PiCreatorDropdown/PiCreatorDropdownItem";
import { useMemo } from "react";

export default function NodeAttachTypeDropdown(props: {
  playerToProp: boolean;
  onChange: (playerToProp: boolean) => void;
}) {
  const { playerToProp, onChange } = { ...props };

  const options = [
    <PiCreatorDropdownItem
      key="prop-to-player"
      text="Prop to Player"
      icon={<></>}
      onClick={() => onChange(false)}
    />,
    <PiCreatorDropdownItem
      key="player-to-prop"
      text="Player to Prop"
      icon={<></>}
      onClick={() => onChange(true)}
    />,
  ];

  const trigger = useMemo(() => {
    return (
      <div
        className={
          "flex items-center w-full h-full font-normal gap-[10px] px-[12px] text-creator-text-sub text-[12px]"
        }
      >
        <div className={"my-auto truncate"}>
          {playerToProp ? "Player to Prop" : "Prop to Player"}
        </div>
      </div>
    );
  }, [playerToProp]);

  return (
    <PiCreatorDropdown
      style="small"
      label={"Attachment Type"}
      trigger={trigger}
      items={options as JSX.Element[]}
    />
  );
}
